import { gql } from '@apollo/client';

// Misure grezze del giorno per un singolo impianto. Usata solo all'apertura
// della card (modale), cosi' il caricamento iniziale non paga il dettaglio ad
// alta risoluzione. Veloce grazie all'indice measure (plant_id, date DESC).
const getPlantMeasuresQuery = gql`
    query getPlantMeasures($plantId: Int!, $date: timestamp!) {
        measure(
            where: { plant_id: { _eq: $plantId }, date: { _gte: $date } }
            order_by: { date: asc }
        ) {
            date
            power
        }
    }
`;

export default getPlantMeasuresQuery;
